import directives from '@/directives'

export default ({ vue }) => {

    for(let directive in directives) {
        const current = directives[directive]
        vue.directive(current.name, current)
    }
}